import axios from 'axios'
import SockJS from 'sockjs-client'
import Stomp from 'stomp-websocket'

const env = (process.env.NODE_ENV === 'production')

const config = () => {
  return {
    url: env ? 'https://fdc-api.brique.kr' : 'http://localhost',
    webSocketUrl: env ? 'https://fdc-ws.brique.kr' : 'http://localhost',
    port: env ? '' : ':'.concat('20004'),
    service: '/fdc/monitor'
  }
}

export default {
  /**
   * Dashboard
   */
  /**
   * @GetMapping value = "/eqp-status"
   * @ApiOperation value = "Equipment 현황 조회", notes = "장비 현황 조회", tags = {"전체 장비 건수", "실행 중인 장비 건수"}
   */
  getEqpStatus: async (payload, callback) => {
    let url = config().url.concat(config().port, config().service, '/dashboard/eqp-status')

    await axios
      .get(url, { params: payload })
      .then(response => {
        callback(response)
      })
      .catch(err => {
        console.error(err)
      })
  },
  /**
   * @GetMapping value = "/model-status"
   * @ApiOperation value = "Fault Detection Model 현황 조회", notes = "이상 감지 모델 현황 조회", tags = {"전체 모델 건수", "적용 모델 건수"}
   */
  getModelStatus: async (payload, callback) => {
    let url = config().url.concat(config().port, config().service, '/dashboard/model-status')

    await axios
      .get(url, { params: payload })
      .then(response => {
        callback(response)
      })
      .catch(err => {
        console.error(err)
      })
  },
  /**
   * @GetMapping value = "/detection-status"
   * @ApiOperation value = "Fault Detection 현황 조회", notes = "이상 감지 건수 현황 조회", tags = {"Warning 건수", "Fault 건수"}
   */
  getDetectionStatus: async (payload, callback) => {
    let url = config().url.concat(config().port, config().service, '/dashboard/detection-status')

    await axios
      .get(url, { params: payload })
      .then(response => {
        callback(response)
      })
      .catch(err => {
        console.error(err)
      })
  },
  /**
   * @GetMapping value = "/alarm-status"
   * @ApiOperation value = "Alarm 현황 조회", notes = "장비 알람, Fault 알람 현황 조회", tags = {"장비 알람 건수", "Fault 알람 건수"}
   */
  getAlarmStatus: async (payload, callback) => {
    let url = config().url.concat(config().port, config().service, '/dashboard/alarm-status')

    await axios
      .get(url, { params: payload })
      .then(response => {
        callback(response)
      })
      .catch(err => {
        console.error(err)
      })
  },
  /**
   * @GetMapping value = "/fault-detection-status"
   * @ApiOperation value = "실시간 Fault, Warning 발생 건수 조회", notes = "실시간 Fault, Waring 알람 정보 조회", tags = {"Warning 건수", "Fault 건수"}
   */
  getFaultDetectionStatus: async (payload, callback, targets) => {
    let url = config().url.concat(config().port, config().service, '/dashboard/fault-detection-status')

    await axios
      .get(url, { params: payload }, targets)
      .then(response => {
        callback(response)
      })
      .catch(err => {
        console.error(err)
      })
  },
  /**
   * @GetMapping value = "/fault-detail"
   * @ApiOperation value = "Fault 상세 조회", notes = "Fault Model, Value 등 상세 정보 조회", tags = {"Fault 정보 상세 조회"}
   */
  getFaultDetail: async (payload, callback, targets) => {
    let url = config().url.concat(config().port, config().service, '/dashboard/fault-detail')

    await axios
      .get(url, { params: payload }, targets)
      .then(response => {
        callback(response)
      })
      .catch(err => {
        console.error(err)
      })
  },
  /**
   * @GetMapping value = "/detection-top-rank"
   * @ApiOperation value = "Detection Model Top Rank", notes = "이상 검출 Model TOP 10", tags = {"이상 검출 모델 건수 TOP10"}
   */
  getDetectionModelTopLank: async (payload, callback, targets) => {
    let url = config().url.concat(config().port, config().service, '/dashboard/detection-top-rank')

    await axios
      .get(url, { params: payload }, targets)
      .then(response => {
        callback(response)
      })
      .catch(err => {
        console.error(err)
      })
  },
  /**
   * @GetMapping value = "/fault-by-fab"
   * @ApiOperation value = "Monthly Fault Stats By Fab", notes = "월별, Fab별 이상 검출 현황", tags = {"월별, Fab별 이상검출 현황"}
   */
  getMonthlyFaultStatsByFab: async (payload, callback, targets) => {
    let url = config().url.concat(config().port, config().service, '/dashboard/fault-by-fab')

    await axios
      .get(url, { params: payload }, targets)
      .then(response => {
        callback(response)
      })
      .catch(err => {
        console.error(err)
      })
  },
  /**
   * @GetMapping value = "/fault-by-area"
   * @ApiOperation value = "Monthly Fault Stats By Area", notes = "월별, Area별 이상 검출 현황", tags = {"월별, Area별 이상검출 현황"}
   */
  getMonthlyFaultStatsByArea: async (payload, callback, targets) => {
    let url = config().url.concat(config().port, config().service, '/dashboard/fault-by-area')

    await axios
      .get(url, { params: payload }, targets)
      .then(response => {
        callback(response)
      })
      .catch(err => {
        console.error(err)
      })
  },
  /**
   * @GetMapping value = "/fault-of-area"
   * @ApiOperation value = "Daily Fault Stats Of Area", notes = "일자별, Area별 이상검출 현황", tags = {"일자별, Area별 이상검출 현황"}
   */
  getDailyFaultStatsOfArea: async (payload, callback, targets) => {
    let url = config().url.concat(config().port, config().service, '/dashboard/fault-of-area')

    await axios
      .get(url, { params: payload }, targets)
      .then(response => {
        callback(response)
      })
      .catch(err => {
        console.error(err)
      })
  },
  /**
   * @GetMapping value = "/set-info"
   * @ApiOperation value = "Setting 정보 조회", notes = "Setting 정보 조회"
   */
  getSetInfo: async (payload, callback) => {
    let url = config().url.concat(config().port, config().service, '/dashboard/set-info')

    await axios
      .get(url, { params: payload })
      .then(response => {
        callback(response)
      })
      .catch(err => {
        console.error(err)
      })
  },

  /**
   * EQP Status Monitor
   */
  getEqpsStatus: async (fab, eqpId, moduleId) => {
    console.log('getEQPState')
    let fabArr = replaceComma(JSON.stringify(fab))
    let eqpIdArr = replaceComma(JSON.stringify(eqpId))
    let moduleIdArr = replaceComma(JSON.stringify(moduleId))

    function replaceComma (str) {
      str = str.replace('[', '')
      str = str.replace(']', '')
      str = str.replace(/\"/g, '')
      return str
    }

    try {
      let response = await axios.get(config().url + config().port + config().service + '/eqps/status', { params: { fab: fabArr, eqpId: eqpIdArr, moduleId: moduleIdArr } })
      return response.data
    } catch (error) {
      console.error(error)
    }
  },

  /**
   * Realtime Monitor
   */
  startRealtimeMonitor: async (payload) => {
    try {
      // FIXME: 아래 항목은 서버에 직접 붙는 버전
      // let response = await axios.post(config().url + ':20002' + '/fdc/rts/realtime-monitor/start', payload)
      let response = await axios.post(config().webSocketUrl + '/fdc/rts/realtime-monitor/start', payload)
      // FIXME: 아래 항목은 hostIp를 사용하는 버전의 소스
      // let url = (env ? 'https://' : 'http://') + payload.hostIp
      // let response = await axios.post(url + config().port + '/fdc/rts/realtime-monitor/start', payload)
      return response.data
    } catch (error) {
      console.log(error)
    }
  },
  stopRealtimeMonitor: async (payload) => {
    try {
      // FIXME: 아래 항목은 서버에 직접 붙는 버전
      // let response = await axios.post(config().url + ':20002' + '/fdc/rts/realtime-monitor/stop', payload)
      let response = await axios.post(config().webSocketUrl + '/fdc/rts/realtime-monitor/stop', payload)
      // FIXME: 아래 항목은 hostIp를 사용하는 버전의 소스
      // let url = (env ? 'https://' : 'http://') + payload.hostIp
      // let response = await axios.post(url + config().port + '/fdc/rts/realtime-monitor/stop', payload)
      return response.data
    } catch (error) {
      console.log(error)
    }
  },
  connectStomp: () => {
    // var sock = new SockJS(config().url + ':20002' + '/fdc/rts/ws-stomp')
    var sock = new SockJS(config().webSocketUrl + '/fdc/rts/ws-stomp')
    var stomp = Stomp.over(sock)
    // 기본 console 제거
    stomp.debug = null
    return stomp
  },
  // 별도의 method
  // connectStomp: (payload) => {
  //   let url = 'http://'+payload.hostIp
  //   console.log("SockJS url :" + url )
  //   var sock = new SockJS(url + config().port+ '/ws-stomp')
  //   var stomp = Stomp.over(sock)
  //   // 기본 console 제거
  //   stomp.debug = null
  //   return stomp
  // }

  /**
   * Lot History
   */
  getEqpsLots: async (params) => {
    try {
      let response = await axios.get(config().url + config().port + config().service + '/eqps/lots', { params: params })
      return response.data === null ? [] : response.data
    } catch (error) {
      console.error(error)
    }
  },

  /**
   * Event History
   */
  getEqpsEvents: async (params) => {
    console.log('getEqpEventHistoryList')
    try {
      let response = await axios.get(config().url + config().port + config().service + '/eqps/events', { params: params })
      return response.data === null ? [] : response.data
    } catch (error) {
      console.error(error)
    }
  },

  /**
   * EQP Alarm History
   */
  getEqpsAlarms: async (payload) => {
    console.log('getAlarmAnalysisReport')
    const url = config().url.concat(config().port, config().service, '/eqps/alarms')
    const result = await axios
      .get(url, { params: payload })
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.error(err)
      })
    return result
  }

}
